import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "playlistId"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useQuery } from '@tanstack/react-query';
import api from 'utils/api';
import assetKeys from './queryKeys';
function useFetchMyAsset(_ref) {
  var id = _ref.id,
    playlistId = _ref.playlistId,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  var url = playlistId ? "/api/me/assets/".concat(id, "/playlist/").concat(playlistId) : "/api/me/assets/".concat(id);
  function getAsset() {
    return _getAsset.apply(this, arguments);
  }
  function _getAsset() {
    _getAsset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('get', url, null));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _getAsset.apply(this, arguments);
  }
  var _useQuery = useQuery(_objectSpread(_objectSpread({
      queryKey: assetKeys.myAsset(id, playlistId),
      queryFn: getAsset
    }, queryOptions), {}, {
      staleTime: 5 * 60 * 1000
    })),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    data: data
  }, result);
}
export default useFetchMyAsset;